var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMembershipStandard22X12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 12,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.792.503h-6.579c-1.218 0-2.217.99-2.217 2.208V9.27c0 1.218.99 2.208 2.217 2.208h6.57c1.228 0 2.218-.99 2.218-2.208V2.702a2.2 2.2 0 0 0-2.2-2.2",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.796.52H2.217C.99.52 0 1.51 0 2.73v6.559c0 1.218.99 2.208 2.217 2.208h6.57c1.228 0 2.217-.99 2.217-2.208V2.719A2.2 2.2 0 0 0 8.806.521",
  fill: "#1A2E80"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.18 9.214a.716.716 0 0 1-1.43 0 .716.716 0 0 1 1.43 0Z",
  fill: "#2E80FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.807 6.716a.787.787 0 0 0-.587.302c-.366.43-.87.76-1.512.76A1.787 1.787 0 0 1 3.913 6.01c0-.943.77-1.768 1.795-1.768.651 0 1.146.34 1.512.76.12.156.358.303.587.303.43 0 .724-.32.724-.678a.722.722 0 0 0-.12-.421c-.586-.862-1.52-1.402-2.703-1.402-1.823 0-3.243 1.402-3.243 3.206 0 1.805 1.42 3.207 3.243 3.207 1.173 0 2.117-.55 2.703-1.402a.722.722 0 0 0 .12-.421c0-.358-.294-.678-.724-.678Z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.18 9.214a.716.716 0 0 1-1.43 0 .716.716 0 0 1 1.43 0Z",
  fill: "#2E80FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.781 3.519a.716.716 0 0 1 1.43 0v1.758h1.767a.716.716 0 0 1 0 1.429H17.21v1.778a.716.716 0 0 1-1.43 0V6.706h-1.77a.716.716 0 0 1 0-1.43h1.77V3.52Z",
  fill: "#fff"
})));
export default SvgIcMembershipStandard22X12;